import React, { useEffect, useState } from 'react'
import MaintenanceIcon from '../../../images/icon_maintenance_yellow.svg'
import GameUnavailableIcon from '../../../images/icon_game-not-available.svg'
import { Button } from '../../atoms/button'
import { Text } from '../../atoms/text'
import { useTranslation } from '../../../context/translationProvider'
import { StyledUnavailabilityWrapper } from './styles'

const GameUnavailable = (props) => {
  const { reason, casinoBackLink, liveCasinoSlug, iframeStyle } = props
  const [message, setMessage] = useState()
  const [icon, setIcon] = useState()
  const { translate } = useTranslation()

  useEffect(() => {
    if (reason === 'maintenance') {
      setIcon(MaintenanceIcon)
      setMessage(translate('game.maintenance_mode_message'))
    } else {
      setIcon(GameUnavailableIcon)
      setMessage(translate('game.geo_blocked_message'))
    }
  }, [reason])

  if (reason === 'auto-withdrawal-enabled')
    return <div style={iframeStyle}></div>

  return (
    <StyledUnavailabilityWrapper style={iframeStyle} reason={reason}>
      <img src={icon} alt="The game is unavailable" />
      <Text>{message}</Text>
      <Button href={casinoBackLink}>
        {casinoBackLink.includes(liveCasinoSlug)
          ? translate('game.go_live_casino')
          : translate('game.go_casino')}
      </Button>
    </StyledUnavailabilityWrapper>
  )
}
export { GameUnavailable }
